// extracted by mini-css-extract-plugin
export default {"liveCursorsContainer":"LiveCursors_liveCursorsContainer__BWYk-"};